jQuery(document).ready(function($) {


  $(function () {
    $('[href="#salads-menu"]').on("click", function (e) {
      e.preventDefault()
      e.stopPropagation()
      window.open(
        '/salads',
        '_blank' // <- This is what makes it open in a new window.
      );
      // location.href = '/salads', '_blank'
    })
  })

  function getUrlQueryParams(){
    if ($('#urlCat').data('urlcat')) {
      return '#' + $('#urlCat').data('urlcat') + '-menu';
    } else {
      return false;
    }
  }
  function changeBttnHref(){
    $('#food-slider').on('afterChange', (slick, currentSlide)=>{
      href = $('#food-slider .slick-current.slick-active').find('a.primary-bttn-alt.show-for-medium').attr('href');
      $('#food-slider-buttons .primary-bttn-alt').attr('href', href);
    })
  }
  changeBttnHref();

  class MenuIndicator {
    constructor($root) {
      this.root = $root
      this.activeItem = $(this.root.find('li.is-active'));
      this.activeSubItem = this.activeItem.children('a');
      this.indicator = $(this.root.find('.menu-indicator'));
      this.root.on('change.zf.tabs', this.render.bind(this, 600));
      this.render( 0 );
    }
    render(duration, event, tab) {
      if (tab) {
        this.activeSubItem.removeClass('is-active');
        this.activeItem = $(tab);
        this.activeSubItem = this.activeItem.children('a');
        this.indicator.css('display', 'inline-block');
      }
      this.indicator.finish().animate({
        'width' : this.activeSubItem.width(),
        'left' : this.activeSubItem.offset().left - this.root.offset().left
      }, duration, function() {
        this.activeSubItem.addClass('is-active');
      }.bind(this));
    }
  }

  if ($('#form-tabs').length) {
    let formIndicators = [];
    let $formCatergories = $('#form-tabs');
    function initializeForm(){
      $('#form-tabs').each(function(i, tab){
        formIndicators.push(new MenuIndicator($(tab)));
      })
    }
    initializeForm();
  }

  if ($('.menu-outer-container').length) {
    const $window = $(window);
    const $doc = $(document);
    const $catBox = $('#cat-box');
    const $outerContainer = $('.menu-outer-container');

    let menuIndicators = [];
    let menuCategoryIndicators = [];
    let $menuCategories = $('.menu-category-tabs');
    let $menuCategoriesItems = $('.menu-category-tabs li');
    let activeSubTabIndex = 0;



    function initializeMenu(){
      $('.menu-tabs').each(function(i, tab){
        menuIndicators.push(new MenuIndicator($(tab)));
      })
      $menuCategories.each(function(i, tab){
        menuCategoryIndicators.push(new MenuIndicator($(tab)));
      })
    }
    initializeMenu();


    $menuCategories.on('change.zf.tabs', function(e, tab, panel) {
      activeSubTabIndex = $menuCategoriesItems.index(tab)
      menuIndicators[activeSubTabIndex].render(0);
    })
    $window.on('load', function() {
      menuCategoryIndicators[0].render(0);
      menuIndicators[activeSubTabIndex].render(0);
    })
    $window.on('resize', function(){
      menuCategoryIndicators[0].render(0);
      menuIndicators[activeSubTabIndex].render(0);
    })

    $('.mobile-menu-categories').on('click', (event) => {
      if (window.outerWidth < 640) {
        $this = $(event.currentTarget);
        if (!$this.hasClass('open')) {
          $this.addClass('open');
          $this.find('ul').slideDown()
        } else {
          $this.find('ul').slideUp(function(){
            $this.removeClass('open');
          });
        }
      }
    })
  // function displayBlock(){
  //   if ($('.mobile-menu-categories > tabs').css('display', 'none')) {
  //     $('.mobile-menu-categories > tabs').css('display', 'flex');
  //   }
  // }
  // $window.on('resize', displayBlock);


    $('.mobile-menu-categories li a').on('click', function(e){
      $('.menu-categories').removeClass('active');
    })


    $('.menu-categories li').on('click', function(e){
      if (window.outerWidth < 640) {
        let target_element = $(this).find('a').attr('href');
        if (target_element.includes('pizza')) {
          $('html, body').animate({scrollTop: $(target_element).offset().top - 298}, 'slow');
        } else{
          $('html, body').animate({scrollTop: $(target_element).offset().top - 248}, 'slow');
        }

      }
    })

    let categoryIndicator = $('#cat-box .hide-for-medium');


    $('.mobile-menu-categories li a').on('click', function() {
      if (window.outerWidth < 640) {
        let $this = $(this);
        let target_element = $this.attr('href');
        categoryIndicator.text($this.text());
        $catBox.removeClass('open');
        if (target_element == '#pizza-menu') {
          $catBox.find('ul').slideUp(400, function() {
            $('html, body').animate({scrollTop: $(target_element).offset().top - 280}, 'slow');
          });
        } else{
          $catBox.find('ul').slideUp(400, function() {
            $('html, body').animate({scrollTop: $(target_element).offset().top - 230}, 'slow');
          });
        }
        setTimeout(love.bind(this, $(event.currentTarget)), 1000);
      }
    })



    let menuOffsetTop = $('.menu-outer-container').offset().top - 120;
    let menuOffsetBottom = menuOffsetTop + $outerContainer.height() + 390;


    function getOffsets() {
      menuOffsetTop = $('.menu-outer-container').offset().top - 120;
      menuOffsetBottom = menuOffsetTop + $outerContainer.height() + 390;
    }

    function love(a){
      $this = a;
      let dataCat = $this.attr('data-cat');
      $('#' + dataCat + '-menu').find('.menu-categories').addClass('active');
    }

    $window.on('resize', getOffsets);
    $doc.on('change.zf.tabs', getOffsets);


    function stickCategories() {
      if (window.innerWidth < 640) {
        let scroll = $window.scrollTop();
        if (scroll >= menuOffsetTop && (scroll + window.innerHeight < menuOffsetBottom) && !($catBox.hasClass('fixed'))) {
            $catBox.addClass('fixed');
            $outerContainer.addClass('padding');
        }
        else if ((scroll + window.innerHeight >= menuOffsetBottom || scroll < menuOffsetTop) && $catBox.hasClass('fixed')) {
          $catBox.removeClass('fixed');
          $outerContainer.removeClass('padding');
          $('.menu-categories').removeClass('active');
        }
      }
    }


    $window.on('scroll resize orientationchange', stickCategories);
}

  let queryParam = getUrlQueryParams();
  if (window.innerWidth < 640 && queryParam) {
    getUrlQueryParams();
    $(window).load(()=>{
      setTimeout($('html, body').animate({scrollTop: $(queryParam).offset().top - 248}, 2000), 2000);
    })
  }
})
